import { Popover } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { Hotel, Utensils, Briefcase, HeartPulse, Home, ShoppingCart } from "lucide-react";
import { useAuth } from "../../../Contexts/AuthContext/AuthContext";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import onelyk from "../../../Assets/onelyklogo.svg";
import { LocalStorage } from "../../../utils";
import ForgotPassword from "../ForgotPassword/ForgotPassword";
import ResetPassword from "../ForgotPassword/ResetPassword";
import AuthOrDivider from "../AuthOrDivider";
import GoogleAuthButton from "../GoogleAuthButton";
import { useGoogleLogin, useGoogleOAuth } from "@react-oauth/google";

export default function Login() {
  const accessToken = LocalStorage.get("accessToken");
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname.split("/")[1];
  const [formData, setFormData] = useState({ email: "", password: "" });
  const { login, loginWithGoogle } = useAuth();
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const { scriptLoadedSuccessfully } = useGoogleOAuth();
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const [rememberMe, setRememberMe] = useState(true);

  const startGooglePopup = useGoogleLogin({
    flow: "auth-code",
    ux_mode: "popup",
    onSuccess: (codeResponse) => {
      loginWithGoogle(codeResponse.code, setGoogleLoading);
    },
    onError: () => {
      toast.error("Google sign-in was not authorized.");
      setGoogleLoading(false);
    },
    onNonOAuthError: () => {
      setGoogleLoading(false);
    },
  });

  const handleGoogleClick = () => {
    if (!process.env.REACT_APP_GOOGLE_CLIENT_ID) {
      toast.info(
        "Add REACT_APP_GOOGLE_CLIENT_ID to enable Google popup sign-in. Your backend should accept POST /api/auth/google.",
      );
      return;
    }
    if (!scriptLoadedSuccessfully) {
      toast.warning(
        "Google sign-in is still loading. Try again in a moment.",
      );
      return;
    }
    setGoogleLoading(true);
    startGooglePopup();
  };

  useEffect(() => {
    const checkTokenAndNavigate = () => {
      if (accessToken) {
        try {
          navigate("/dashboard");
        } catch (error) {
          toast.error("Invalid token. Please login again.");
          navigate("/");
        }
      }
    };

    checkTokenAndNavigate();
  }, [accessToken, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading spinner

    try {
      await login(formData.email, formData.password, rememberMe);
    } catch (error) {
      console.error("Login failed:", error);
    } finally {
      setLoading(false); // Stop loading spinner
    }
  };

  return (
    <>
      {loading && <LoadingSpinner />}
      <div className="relative overflow-hidden bg-gray-800 min-h-screen ">
        <div
          aria-hidden="true"
          className="hidden sm:absolute sm:inset-0 sm:block"
        >
          <svg
            fill="none"
            width={364}
            height={384}
            viewBox="0 0 364 384"
            className="absolute bottom-0 right-0 mb-48 translate-x-1/2 transform text-gray-700 lg:top-0 lg:mb-0 lg:mt-28 xl:translate-x-0 xl:transform-none"
          >
            <defs>
              <pattern
                x={0}
                y={0}
                id="eab71dd9-9d7a-47bd-8044-256344ee00d0"
                width={20}
                height={20}
                patternUnits="userSpaceOnUse"
              >
                <rect x={0} y={0} fill="currentColor" width={4} height={4} />
              </pattern>
            </defs>
            <rect
              fill="url(#eab71dd9-9d7a-47bd-8044-256344ee00d0)"
              width={364}
              height={384}
            />
          </svg>
        </div>

        <div className="relative pb-16 pt-6 sm:pb-24">
          <Popover>
            <nav
              aria-label="Global"
              className="relative mx-auto flex max-w-7xl items-center justify-between px-6"
            >
              <div className="flex flex-1 items-center">
                <div className="flex w-full items-center justify-between md:w-auto">
                  <a href="#">
                    <span className="sr-only">Your Company</span>
                    <img alt="" src={onelyk} className="h-8 w-auto sm:h-10" />
                  </a>
                  {/* <div className="-mr-2 flex items-center md:hidden">
                  <PopoverButton className="focus-ring-inset relative inline-flex items-center justify-center rounded-md bg-gray-800 p-2 text-gray-400 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-white">
                    <span className="absolute -inset-0.5" />
                    <span className="sr-only">Open main menu</span>
                    <Bars3Icon aria-hidden="true" className="h-6 w-6" />
                  </PopoverButton>
                </div> */}
                </div>
                {/* <div className="hidden space-x-10 md:ml-10 md:flex">
                {navigation.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className="font-medium text-white hover:text-gray-300"
                  >
                    {item.name}
                  </a>
                ))}
              </div> */}
              </div>
              {/* <div className="hidden md:flex">
              <a
                href="#"
                className="inline-flex items-center rounded-md border border-transparent bg-gray-600 px-4 py-2 text-sm font-medium text-white hover:bg-gray-700"
              >
                Onboard New Property
              </a>
            </div> */}
            </nav>

            {/* <PopoverPanel
            focus
            transition
            className="absolute inset-x-0 top-0 z-10 origin-top-right transform p-2 transition data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-150 data-[leave]:duration-100 data-[enter]:ease-out data-[leave]:ease-in md:hidden"
          >
            <div className="overflow-hidden rounded-lg bg-white shadow-md ring-1 ring-black ring-opacity-5">
              <div className="flex items-center justify-between px-5 pt-4">
                <div>
                  <img
                    alt=""
                    src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600"
                    className="h-8 w-auto"
                  />
                </div>
                <div className="-mr-2">
                  <PopoverButton classNamListinge="relative inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                    <span className="absolute -inset-0.5" />
                    <span className="sr-only">Close menu</span>
                    <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                  </PopoverButton>
                </div>
              </div>
              <div className="space-y-1 px-2 pb-3 pt-2">
                {navigation.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className="block rounded-md px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900"
                  >
                    {item.name}
                  </a>
                ))}
              </div>
              <a
                href="#"
                className="block w-full bg-gray-50 px-5 py-3 text-center font-medium text-indigo-600 hover:bg-gray-100"
              >
                Log in
              </a>
            </div>
          </PopoverPanel> */}
          </Popover>

          <main className="mt-16 sm:mt-24 ">
            <div className="mx-auto max-w-7xl ">
              <div className="flex flex-col-reverse lg:grid lg:grid-cols-12 lg:gap-8">
                <div className="px-6 sm:text-center md:mx-auto md:max-w-2xl lg:col-span-6 lg:flex lg:items-center lg:text-left mt-8 sm:mt-10 lg:mt-0">
                  <div>
                    {/* contact us and visit webiste */}
                    <div className="hidden sm:mb-4 sm:flex sm:justify-center lg:justify-start">
                      <div className="flex items-center rounded-full bg-gray-900 p-1 pr-2 text-white hover:text-gray-200 sm:text-base lg:text-sm xl:text-base">
                        <span className="rounded-full bg-indigo-500 px-3 py-0.5 text-sm font-medium leading-5 text-white uppercase">
                          <a href="/register">Onboard New</a>
                        </span>
                        <a href="https://www.onelyk.com/">
                          <span className="ml-4 text-sm">
                            Visit our website
                          </span>
                        </a>
                        <ChevronRightIcon
                          aria-hidden="true"
                          className="ml-2 h-5 w-5 text-gray-500"
                        />
                      </div>
                    </div>

                    <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl md:text-5xl mb-2">
                      Celebrating success
                    </h1>
                    <h1 className="text-4xl font-bold tracking-tight text-indigo-400 sm:text-5xl md:text-5xl">
                      possible with us
                    </h1>
                    <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-lg">
                      This approach consolidates all customers information and
                      updates into a single, accessible link. It centralizes
                      review & rating management, and personalized
                      recommendations, providing real-time updates and reducing
                      the need for multiple communications.
                    </p>

                    <p className="mt-8 text-base font-semibold text-white sm:mt-10">
                      Used by
                    </p>
                    <div className="mt-5 w-full sm:mx-auto sm:max-w-lg lg:ml-0">
                      <div className="grid grid-cols-3 gap-y-6 gap-x-2 sm:gap-x-4">
                        <div className="flex flex-col items-center justify-start text-gray-400 hover:text-indigo-400 transition-colors">
                          <Hotel className="h-7 w-7 sm:h-8 sm:w-8 mb-2" />
                          <span className="text-[10px] sm:text-xs font-medium text-center whitespace-nowrap">Hospitality</span>
                        </div>
                        <div className="flex flex-col items-center justify-start text-gray-400 hover:text-indigo-400 transition-colors">
                          <Utensils className="h-7 w-7 sm:h-8 sm:w-8 mb-2" />
                          <span className="text-[10px] sm:text-xs font-medium text-center whitespace-nowrap">Food & Dining</span>
                        </div>
                        <div className="flex flex-col items-center justify-start text-gray-400 hover:text-indigo-400 transition-colors">
                          <Briefcase className="h-7 w-7 sm:h-8 sm:w-8 mb-2" />
                          <span className="text-[10px] sm:text-xs font-medium text-center whitespace-nowrap">Professional Services</span>
                        </div>
                        <div className="flex flex-col items-center justify-start text-gray-400 hover:text-indigo-400 transition-colors">
                          <HeartPulse className="h-7 w-7 sm:h-8 sm:w-8 mb-2" />
                          <span className="text-[10px] sm:text-xs font-medium text-center whitespace-nowrap">Healthcare & Wellness</span>
                        </div>
                        <div className="flex flex-col items-center justify-start text-gray-400 hover:text-indigo-400 transition-colors">
                          <Home className="h-7 w-7 sm:h-8 sm:w-8 mb-2" />
                          <span className="text-[10px] sm:text-xs font-medium text-center whitespace-nowrap">Property Services</span>
                        </div>
                        <div className="flex flex-col items-center justify-start text-gray-400 hover:text-indigo-400 transition-colors">
                          <ShoppingCart className="h-7 w-7 sm:h-8 sm:w-8 mb-2" />
                          <span className="text-[10px] sm:text-xs font-medium text-center whitespace-nowrap">Retail & Shopping</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-0 mb-8 sm:mb-10 mx-4 sm:mx-6 lg:mx-0 lg:col-span-6 lg:mt-16 lg:mb-0 sm:mt-24">
                  <div className="bg-white sm:mx-auto sm:w-full sm:max-w-md sm:overflow-hidden rounded-lg">
                    {/* sign in options */}
                    {/* <div>
                      <p className="text-sm font-medium text-gray-700">
                        Sign in with
                      </p>

                      <div className="mt-1 grid grid-cols-3 gap-3">
                        <div>
                          <a
                            href="#"
                            className="inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-500 shadow-sm hover:bg-gray-50"
                          >
                            <span className="sr-only">
                              Sign in with Facebook
                            </span>
                            <svg
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              aria-hidden="true"
                              className="h-5 w-5"
                            >
                              <path
                                d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z"
                                clipRule="evenodd"
                                fillRule="evenodd"
                              />
                            </svg>
                          </a>
                        </div>

                        <div>
                          <a
                            href="#"
                            className="inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-500 shadow-sm hover:bg-gray-50"
                          >
                            <span className="sr-only">Sign in with X</span>
                            <svg
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              aria-hidden="true"
                              className="h-5 w-5"
                            >
                              <path d="M11.4678 8.77491L17.2961 2H15.915L10.8543 7.88256L6.81232 2H2.15039L8.26263 10.8955L2.15039 18H3.53159L8.87581 11.7878L13.1444 18H17.8063L11.4675 8.77491H11.4678ZM9.57608 10.9738L8.95678 10.0881L4.02925 3.03974H6.15068L10.1273 8.72795L10.7466 9.61374L15.9156 17.0075H13.7942L9.57608 10.9742V10.9738Z" />
                            </svg>
                          </a>
                        </div>

                        <div>
                          <a
                            href="#"
                            className="inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-500 shadow-sm hover:bg-gray-50"
                          >
                            <span className="sr-only">Sign in with GitHub</span>
                            <svg
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              aria-hidden="true"
                              className="h-5 w-5"
                            >
                              <path
                                d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z"
                                clipRule="evenodd"
                                fillRule="evenodd"
                              />
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div> */}

                    {/* divider */}
                    {/* <div className="relative mt-6">
                      <div
                        aria-hidden="true"
                        className="absolute inset-0 flex items-center"
                      >
                        <div className="w-full border-t border-gray-300" />
                      </div>
                      <div className="relative flex justify-center text-sm">
                        <span className="bg-white px-2 text-gray-500">Or</span>
                      </div>
                    </div> */}

                    {/* sign in logo */}
                    {/* <div>
                      <img
                        className="h-10 w-auto"
                        src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600"
                        alt="Your Company"
                      />
                      <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">
                        Sign in to your account
                      </h2>
                    </div> */}
                    {path === "" ? (
                      <>
                        <div className="px-6 py-8 sm:px-10">
                          <h1 className="text-3xl font-bold tracking-tight text-gray-900">
                            Sign in to your account
                          </h1>

                          <div className="mt-6">
                            <form
                              onSubmit={handleSignIn}
                              method="POST"
                              className="space-y-6"
                            >
                              <div>
                                <label
                                  htmlFor="email"
                                  className="block text-sm font-medium leading-6 text-gray-900 sr-only"
                                >
                                  Email address
                                </label>
                                <div className="mt-2">
                                  <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    required
                                    placeholder="Enter Email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                  />
                                </div>
                              </div>

                              <div>
                                <label
                                  htmlFor="password"
                                  className="sr-only block text-sm font-medium leading-6 text-gray-900"
                                >
                                  Password
                                </label>
                                <div className="mt-2 relative">
                                  <input
                                    id="password"
                                    name="password"
                                    type={showPassword ? "text" : "password"}
                                    autoComplete="current-password"
                                    required
                                    placeholder="Password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 pr-10"
                                  />
                                  <button
                                    type="button"
                                    onClick={togglePasswordVisibility}
                                    className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500"
                                    tabIndex={-1} // Prevents button from being focused on tab
                                  >
                                    {showPassword ? (
                                      <AiOutlineEyeInvisible className="h-5 w-5" />
                                    ) : (
                                      <AiOutlineEye className="h-5 w-5" />
                                    )}
                                  </button>
                                </div>
                              </div>

                              {/* remember me and forgot password */}
                              <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                  <input
                                    id="remember-me"
                                    name="remember-me"
                                    type="checkbox"
                                    className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                                    checked={rememberMe}
                                    onChange={(e) => {
                                      if (e.target.checked === false) {
                                        toast.info(
                                          "You will be logged out in 24 hours."
                                        );
                                      }
                                      setRememberMe(e.target.checked);
                                    }}
                                  />
                                  <label
                                    htmlFor="remember-me"
                                    className="ml-3 block text-sm leading-6 text-gray-700"
                                  >
                                    Remember me
                                  </label>
                                </div>

                                <div className="text-sm leading-6">
                                  <Link
                                    to="/forgotpassword"
                                    className="font-semibold text-indigo-600 hover:text-indigo-500"
                                  >
                                    Forgot password?
                                  </Link>
                                </div>
                              </div>

                              {/* sing in button */}
                              <div>
                                <button
                                  type="submit"
                                  disabled={googleLoading}
                                  className="flex w-full justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-60"
                                >
                                  Sign In
                                </button>
                              </div>

                              <AuthOrDivider />
                              <GoogleAuthButton
                                type="button"
                                loading={googleLoading}
                                disabled={loading}
                                onClick={handleGoogleClick}
                              />

                              <p className="mt-2 text-sm text-gray-700">
                                Don’t have an account?{" "}
                                <Link
                                  to="/register"
                                  className="font-medium text-blue-600 hover:underline"
                                >
                                  Sign up
                                </Link>{" "}
                                for a free trial.
                              </p>

                              {/* google login */}
                              {/* <div className="mt-10">
                          <div className="mt-6 grid grid-cols-1">
                            <a
                              href="#"
                              className="flex w-full items-center justify-center gap-3 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:ring-transparent"
                            >
                              <svg
                                className="h-5 w-5"
                                aria-hidden="true"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  d="M12.0003 4.75C13.7703 4.75 15.3553 5.36002 16.6053 6.54998L20.0303 3.125C17.9502 1.19 15.2353 0 12.0003 0C7.31028 0 3.25527 2.69 1.28027 6.60998L5.27028 9.70498C6.21525 6.86002 8.87028 4.75 12.0003 4.75Z"
                                  fill="#EA4335"
                                />
                                <path
                                  d="M23.49 12.275C23.49 11.49 23.415 10.73 23.3 10H12V14.51H18.47C18.18 15.99 17.34 17.25 16.08 18.1L19.945 21.1C22.2 19.01 23.49 15.92 23.49 12.275Z"
                                  fill="#4285F4"
                                />
                                <path
                                  d="M5.26498 14.2949C5.02498 13.5699 4.88501 12.7999 4.88501 11.9999C4.88501 11.1999 5.01998 10.4299 5.26498 9.7049L1.275 6.60986C0.46 8.22986 0 10.0599 0 11.9999C0 13.9399 0.46 15.7699 1.28 17.3899L5.26498 14.2949Z"
                                  fill="#FBBC05"
                                />
                                <path
                                  d="M12.0004 24.0001C15.2404 24.0001 17.9654 22.935 19.9454 21.095L16.0804 18.095C15.0054 18.82 13.6204 19.245 12.0004 19.245C8.8704 19.245 6.21537 17.135 5.2654 14.29L1.27539 17.385C3.25539 21.31 7.3104 24.0001 12.0004 24.0001Z"
                                  fill="#34A853"
                                />
                              </svg>
                              <span className="text-sm font-semibold leading-6">
                                Google
                              </span>
                            </a>
                          </div>
                        </div> */}
                            </form>
                          </div>
                        </div>

                        {/* Terms and conditions */}
                        <div className="border-t-2 border-gray-200 bg-gray-50 px-6 py-6 sm:px-10">
                          <p className="text-xs leading-5 text-gray-500">
                            By signing up, you agree to our{" "}
                            <a
                              href="#"
                              className="font-medium text-gray-900 hover:underline"
                            >
                              Terms
                            </a>
                            ,{" "}
                            <a
                              href="#"
                              className="font-medium text-gray-900 hover:underline"
                            >
                              Data Policy
                            </a>{" "}
                            and{" "}
                            <a
                              href="#"
                              className="font-medium text-gray-900 hover:underline"
                            >
                              Cookies Policy
                            </a>
                            .
                          </p>
                        </div>
                      </>
                    ) : path === "forgotpassword" ? (
                      <ForgotPassword />
                    ) : (
                      path === "resetpassword" && <ResetPassword />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}
